(function () {
  'use strict';

  /* @ngdoc object
   * @name finance.vckkcat
   * @description
   *
   */
  angular
    .module('finance.vckkcat', [
    ]);
}());
